
    export enum EnumCompanyList {
			Y = 0,
			U = 1,
			R = 2,
			P = 3,
			S = 4,
			N = 5,
    }